const ScrollTo = {
  mounted() {
    this.handleClick = (e) => {
      e.preventDefault();
      let target = document.getElementById(
        this.el.getAttribute("href").substring(1),
      );
      target.scrollIntoView({ behavior: "smooth" });
    };
    this.el.addEventListener("click", this.handleClick);
  },
  destroyed() {
    this.el.removeEventListener("click", this.handleClick);
  },
};

export default ScrollTo;
